<template>
  <div class="question">
    <p class="title">问卷调查</p>
    <div class="list">
      <!-- <div class="list_box">
        <p>创建人：xxx</p>
        <p>创建说明：xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</p>
        <div class="time">
          <p>创建名称：xxxxxxxxxxxxx</p>
          <p style="fontSize:10px;">创建时间：2021-04-26</p>
        </div>
      </div> -->
      <div class="list_box" v-for="(item,index) in list" :key="index" @click="topage(item)">
        <div class="time">
          <p>问卷说明：{{item.description}}</p>
          <p style="fontSize:14px;">创建时间：{{item.createTime}}</p>
        </div>
      </div>
    </div>
    <template v-if="total>0">
      <div>
        <a-pagination
          show-quick-jumper
          :default-current="current"
          :total="total"
          @change="onChange"
        />
        <br />
      </div>
    </template>
    <p v-else>暂无问卷调查</p>
  </div>
</template>

<script>
import { getVotePage,getPage,vote } from "@/api/user-center";
import { ls } from "@/utils/tool";
export default {
  data() {
    return {
      sysUser: ls.get("sysUser"),
      list: [],
      current: 1,
      pageSize: 10,
      total: 0,
    };
  },
  async created() {
    this.init();
    // let res = await getPage({pageNum:1,pageSize:9999})
    // console.log(res)
    // let rs = await vote(res.data.list[0].questionId)
    //   console.log('这是问卷',rs)
  },
  methods: {
    async init() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.current,
      };
      let res = await getVotePage(data);
      console.log(res);
      if (res.code == 200) {
        this.list = res.data.list;
        this.total = res.data.totalCount;
        return;
      }
      this.list = [];
    },
    onChange(pageNumber) {
      window.scrollTo(0, 0);
      this.current = pageNumber;
      this.init();
    },
    topage(item){
      console.log(item)
      // this.$message.warning('还在测试中')
      this.$router.push({path:'/user-center/question_dev',query:{id:item.id}})
    }
  },
};
</script>

<style lang="less" scoped>
.question {
  padding-left: 15px;
  .title {
    font-size: 28px;
    font-weight: 800;
  }
  P:last-child {
    font-size: 20px;
  }
  .list {
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
    .list_box {
      width: 95%;
      padding: 10px;
      // box-shadow: 0 0 5px #ccc;
      border-bottom: 1px solid #ccc;
      cursor: pointer;
      p {
        margin: 0;
        font-size: 22px;
        margin-bottom: 5px;
        white-space: nowrap;
      }
      .time {
        display: flex;
        justify-content: space-between;
        p:last-child{
          position: relative;
          top: 20px;
        }
      }
    }
  }
}
</style>